import tableSportsRoom from './tableRelatedSportsRoom';

export default {
  title: 'Rooms',
  attributeName: 'sportsRooms',
  // getURL: 'roomsPaginated',
  getURL: 'mainHubs/mainHubId/roomsPaginated',
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'name',
  itemId: 'id',
  sessionParams: ['mainHubId'],
  tableConfig: tableSportsRoom,
};
